import React from 'react';

import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import CircularProgress from '@mui/material/CircularProgress';

import clsx from 'clsx';
import useStyles from '../styles/Styles';

const Waiting = (props) => {
	
	const classes = useStyles();
	const Inner = () => (
		<>
		<Typography variant="h6" align="center" gutterBottom>
		{props.message}
		</Typography>
		 <div className={classes.actionButton}>
			<CircularProgress />
		</div>
		</>
	);
	
	return props.withPaper ? (
		<Paper className={clsx(classes.innerContent, classes.page)} square={true} >
		<Inner/>
		</Paper>
	) : <Inner/>
	
}

export default Waiting